import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { loginOktaUser } from "../../api/loginApi";
import { tokenKey, refreshTokenKey, expirationKey } from "../../api/OAuth";
import { setUserAuthenticated } from "../../redux/userIsAuthenticatedReducer";
import { AppRoutes } from "../../AppRoutes";
import LoginFail from "./LoginFail";
import { Spin } from "antd";
import { config } from "../../config";
import { saveUserProfileFromToken } from "../../utils/userProfileUtils";

const OktaCallBack = () => {
    const navigate = useNavigate();

    const dispatch = useDispatch();
    const location = useLocation();
    const { adentis, bee, teamit, codewin, loginPage } = config;

    useEffect(() => {
        const code = new URLSearchParams(location.search).get("code");
        const errorDescription = new URLSearchParams(location.search).get("error_description");
        if (code) {
            let companyId = ''
            if (window.location.host === adentis.host) {
                companyId = adentis.companyId;
            }
            else if (window.location.host === bee.host) {
                companyId = bee.companyId;
            } else if (window.location.host === teamit.host) {
                companyId = teamit.companyId;
            } else if (window.location.host === codewin.host) {
                companyId = codewin.companyId;
            }
            loginOktaUser({ authorizationCode: code, companyId: companyId })
                .then((response) => {

                    localStorage.setItem(tokenKey, response.data.token);
                    localStorage.setItem(refreshTokenKey, response.data.refreshToken);
                    localStorage.setItem(expirationKey, response.data.expiration);
                    saveUserProfileFromToken(response.data.token);
                    dispatch(setUserAuthenticated());

                    navigate(AppRoutes.home.path);
                })
                .catch((error) => {
                    LoginFail(
                        () => navigate(AppRoutes.login.path),
                        "There was an error with your login. Please contact the support team for assistance."
                    );
                });
        } else if (errorDescription) {
            LoginFail(
                () => navigate(AppRoutes.login.path),
                errorDescription + ". Please contact the support team for assistance."
            );
        } else {
            LoginFail(
                () => navigate(AppRoutes.login.path),
                "There was an error with your login. Please contact the support team for assistance."
            );
        }
    }, []);

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
            }}
        >
            <div>
                <Spin size="large">
                    <h1>Processing login</h1>{" "}
                </Spin>
            </div>
        </div>
    );
};

export default OktaCallBack;
